/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionValidationData
 */
export interface AncillaryDistributionValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    ancillaryCategory?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    ancillary?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    carrier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    supplier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    dateRange?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryDistributionValidationData
     */
    relevance?: ValidationMessage;
}

export function AncillaryDistributionValidationDataFromJSON(json: any): AncillaryDistributionValidationData {
    return AncillaryDistributionValidationDataFromJSONTyped(json, false);
}

export function AncillaryDistributionValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : ValidationMessageFromJSON(json['ancillaryCategory']),
        'ancillary': !exists(json, 'ancillary') ? undefined : ValidationMessageFromJSON(json['ancillary']),
        'carrier': !exists(json, 'carrier') ? undefined : ValidationMessageFromJSON(json['carrier']),
        'supplier': !exists(json, 'supplier') ? undefined : ValidationMessageFromJSON(json['supplier']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'dateRange': !exists(json, 'dateRange') ? undefined : ValidationMessageFromJSON(json['dateRange']),
        'relevance': !exists(json, 'relevance') ? undefined : ValidationMessageFromJSON(json['relevance']),
    };
}

export function AncillaryDistributionValidationDataToJSON(value?: AncillaryDistributionValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ancillaryCategory': ValidationMessageToJSON(value.ancillaryCategory),
        'ancillary': ValidationMessageToJSON(value.ancillary),
        'carrier': ValidationMessageToJSON(value.carrier),
        'supplier': ValidationMessageToJSON(value.supplier),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'dateRange': ValidationMessageToJSON(value.dateRange),
        'relevance': ValidationMessageToJSON(value.relevance),
    };
}


